import { createLazyComponent } from '../shared/createLazyComponent';

// Exported separately so App can prefetch this chunk ahead of drawer-open without changing
// the chunk graph. See .claude/context/shell-composition.md.
export const loadAssistantShell = () => import('./AssistantShell');

// rethrowOnError surfaces a failed import to the parent ErrorBoundary, not an unhandled
// rejection (see createLazyComponent).
export const LazyAssistantShell = createLazyComponent(
  loadAssistantShell,
  'AssistantShell',
  { label: 'Assistant Shell', rethrowOnError: true },
);
